import { RepresentationData } from '@ardoq/data-model';
import { ArdoqIconCategory, IconSize } from '@ardoq/icons';
import { EntityIconProps } from './EntityIcon';

const { FontAwesome } = ArdoqIconCategory;
const emptyIcon = {
  id: '',
  isSVG: false,
  category: FontAwesome,
  label: 'None',
  representation: '',
};

export const representationDataToEntityIconProps = ({
  isImage: isImageProp,
  value = '',
  icon = emptyIcon,
  style,
  iconSize,
  color,
}: RepresentationData & {
  style?: React.CSSProperties;
  iconSize?: IconSize;
  color?: string;
}): EntityIconProps => {
  const { id, isSVG, category } = icon;
  const isFontAwesome = category === FontAwesome;
  const isImage = isImageProp && value;

  return {
    style,
    color: style?.color ?? color,
    imageSrc: isImage ? value : undefined,
    iconId: isFontAwesome || isSVG ? id : undefined,
    iconSize,
  };
};
